const getSelectTitle = (type: FilterSection) => {
  switch (type) {
    case 'categories':
      return 'casino.categories';
    case 'providers':
      return 'casino.providers';
    default:
      return 'general.sort_by';
  }
};

export default getSelectTitle;
